import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";



@Component({
  imports: [
    CommonModule,
    FormsModule
  ],
  selector: 'AdminIndex',
  templateUrl: './AdminIndex.html',
  standalone: true,
  styleUrl: './AdminIndex.css'
})
export class AdminIndex {

}
